import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

// The bare URL has no page of its own (an empty outlet), so land on the TAS dashboard.
export default class AuthenticatedTasApplicationsTypeTwoIndexRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    this.router.replaceWith('authenticated.tas.dashboard');
  }
}
